import { POST } from "../../axios/apiService";

export const createOrPersistCompany = async ({ data, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/companies`;
  return POST(url, data, options);
};
